module.exports = __webpack_public_path__ + "media/images/Bricks-6eb51c439cbe2aa35113dcc05923322e.svg";